<template>
    <div class="wrapper">
        <div class="icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g v-html="getIconPath(iconName)"/>
            </svg>
        </div>
        <span class="state-text">{{ stateText }}</span>
        <span class="state-subtext">{{ stateSubText }}</span>
    </div>
</template>
<script setup>
import { getIconPath } from '@/Modules/utils/icons';

defineProps({
    iconName: {
        type: String,
        required: true
    },
    stateText: {
        type: String,
        required: true
    },
    stateSubText: {
        type: String,
        required: true
    }
})
</script>

<style scoped>
.wrapper {
    color: #9ca3af;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.icon {
    opacity: 0.6;
    color: #d1d5db;
}
.state-text {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
}

.state-subtext {
    font-size: 14px;
    font-weight: 400;
    opacity: 0.7;
    text-align: center;
}
</style>